import { TableHead, TableHeader, TableRow } from "@/components/ui/table";

const InspectionTableHeader = () => {
   const columns = [
      { key: 'applicationNumber', label: 'Application Number', width: '20%', align: 'center' },
      { key: 'type', label: 'Type', width: '20%', align: 'center' },
      { key: 'submissionDate', label: 'Submission Date', width: '15%', align: 'center' },


      { key: 'inspectionStatus', label: 'Inspection Status', width: '20%', align: 'center' },
      { key: 'actions', label: 'Actions', width: '10%', align: 'center', className: 'table-actions' }
   ];

   return (
      <TableHeader>
         <TableRow>
            {columns.map((column) => (
               <TableHead
                  key={column.key}
                  className={`w-[${column.width}] ${column.align === 'center' ? 'text-center' : ''} ${column.className || ''}`}
               >
                  {column.label}
               </TableHead>
            ))}
         </TableRow>
      </TableHeader>
   );
};

export default InspectionTableHeader;